<template>
    <div class="container-fluid adminAuditsWrapper">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">監査ログ</div>
                    <div class="card-body pt-2">
                        <div class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                    <span class="small">日時</span>
                                </div>
                                <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <input
                                            v-model="search.created_at_gte"
                                            @change="onChangeSearchCreatedAtGte"
                                            type="date"
                                            class="form-control">
                                    </div>
                                </div>
                                <span class="small mt-2 ml-2">〜</span>
                                <div class="mt-2 mb-2 ml-md-3 mb-md-0 mr-sm-0 mr-md-2">
                                    <div class="input-group input-group-sm">
                                        <input
                                            v-model="search.created_at_lte"
                                            @change="onChangeSearchCreatedAtLte"
                                            type="date"
                                            class="form-control">
                                    </div>
                                </div>
                                <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0 mr-sm-0 mr-md-2">
                                    <div class="input-group input-group-sm">
                                        <select v-model="search.user_type"
                                                @change="onChangeSearchUserType"
                                                id="user_type"
                                                style="min-width: 100px;"
                                                class="form-control">
                                            <option :value="null">モードで検索</option>
                                            <option
                                                v-for="userType in userTypes"
                                                :value="userType.value">
                                                {{ userType.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    v-if="users !== null"
                                    class="d-flex align-items-center mt-2 mr-0 mb-2 mr-md-2 mb-md-0 mr-sm-0 mr-md-2">
                                    <multiselect
                                        v-model="selectedUser"
                                        :options="users"
                                        :placeholder="`${$locale.patient}で検索`"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        :disabled="inProgress"
                                        selectLabel="選択　"
                                        label="label"
                                        track-by="id"
                                        @input="onChangeSearchUserId">
                                    </multiselect>
                                </div>
                                <div
                                    v-if="organizations !== null"
                                    class="d-flex align-items-center mt-2 mr-0 mb-2 mr-md-2 mb-md-0 mr-sm-0 mr-md-2">
                                    <multiselect
                                        v-model="selectedOrganization"
                                        :options="organizations"
                                        placeholder="団体で検索"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        :disabled="inProgress"
                                        selectLabel="選択　"
                                        label="label"
                                        track-by="id"
                                        @input="onChangeSearchOrganizationId">
                                    </multiselect>
                                </div>
                                <div
                                    v-if="companies !== null"
                                    class="d-flex align-items-center mt-2 mr-0 mb-2 mr-md-2 mb-md-0 mr-sm-0 mr-md-2">
                                    <multiselect
                                        v-model="selectedCompany"
                                        :options="companies"
                                        placeholder="法人で検索"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        :disabled="inProgress"
                                        selectLabel="選択　"
                                        label="label"
                                        track-by="id"
                                        @input="onChangeSearchCompanyId">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-3 mt-md-2 mb-2 mb-md-0 ml-0 ml-md-2 text-right">
                                    <button
                                        type="button"
                                        class="btn btn-yokumiru-orange btnCsvDownload"
                                        @click="onCsvDownload">
                                        CSVダウンロード
                                    </button>
                                </div>
                            </div>
                        </div>

<!--                        <div v-if="audits">-->
<!--                            <b-table-->
<!--                                hover-->
<!--                                striped-->
<!--                                responsive-->
<!--                                :items="audits"-->
<!--                                :fields="fields"-->
<!--                                :sort-by.sync="$store.state.adminAudits.sortBy"-->
<!--                                :sort-desc.sync="$store.state.adminAudits.sortDesc"-->
<!--                                @sort-changed="fetchAudits"-->
<!--                                class="table-bordered m-table">-->
<!--                            </b-table>-->

<!--                            <div class="d-flex flex-wrap justify-content-between align-items-center">-->
<!--                                <b-pagination-->
<!--                                    :total-rows="$store.state.adminAudits.total"-->
<!--                                    :per-page="$store.state.adminAudits.per_page"-->
<!--                                    v-model="$store.state.adminAudits.current_page"-->
<!--                                    @change="fetchAudits">-->
<!--                                </b-pagination>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div -->
<!--                            v-else-->
<!--                            class="p-5 d-flex justify-content-center align-items-center">-->
<!--                            <b-spinner variant="yokumiru-admin"/>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'
import Multiselect from 'vue-multiselect'
import { mapMutations } from 'vuex'

export default {
    components: { Multiselect },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            audits: null,
            users: null,
            organizations: null,
            companies: null,
            selectedUser: null,
            selectedOrganization: null,
            selectedCompany: null,
            search: {
                created_at_gte: '',
                created_at_lte: '',
                user_type: null,
                user_id: null,
                organization_id: null,
                company_id: null,
            },
            userTypes: [
                { text: this.$locale.patient, value: 'App\\Models\\User' },
                { text: '医師', value: 'App\\Models\\Doctor' },
                { text: '管理者', value: 'App\\Models\\Admin' },
                { text: 'SYSTEM', value: 'SYSTEM' },
            ],
            // fields: [
            //     {
            //         'key': 'id',
            //         'label': '#',
            //         sortable: true,
            //     },
            // ],
        }
    },

    computed: {
        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.$store.state.adminAudits.total < 1) {
                return ''
            }
            return `全${this.$store.state.adminAudits.total}件中 ${this.$store.state.adminAudits.from}～${this.$store.state.adminAudits.to}件表示`
        },
    },

    created: async function () {
        await this.fetchUsersMultiselect()
        await this.fetchOrganizationsMultiselect()
        await this.fetchCompaniesMultiselect()

        this.initQueryFromState()
        this.initSearchCondition()
        await this.fetchAudits()
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminAudits/setQuery',
            setQueries: 'adminAudits/setQueries',
        }),

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminAudits) {
                    this.setQueries(data.adminAudits)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.created_at_gte = this.$store.state.adminAudits.created_at_gte
            this.search.created_at_lte = this.$store.state.adminAudits.created_at_lte
            this.search.user_type = this.$store.state.adminAudits.user_type
            this.search.user_id = this.$store.state.adminAudits.user_id
            this.search.organization_id = this.$store.state.adminAudits.organization_id
            this.search.company_id = this.$store.state.adminAudits.company_id

            if (this.search.user_id) {
                this.selectedUser = this.users.find((user) => user.id === this.search.user_id)
            }
            if (this.search.organization_id) {
                this.selectedOrganization = this.organizations.find((organization) => organization.id === this.search.organization_id)
            }
            if (this.search.company_id) {
                this.selectedCompany = this.companies.find((company) => company.id === this.search.company_id)
            }
        },

        onChangeSearchCreatedAtGte: async function () {
            await this.setQuery({ key: 'created_at_gte', value: this.search.created_at_gte })
            await this.fetchAudits(1)
        },

        onChangeSearchCreatedAtLte: async function () {
            await this.setQuery({ key: 'created_at_lte', value: this.search.created_at_lte })
            await this.fetchAudits(1)
        },

        onChangeSearchUserType: async function () {
            await this.setQuery({ key: 'user_type', value: this.search.user_type })
            await this.fetchAudits(1)
        },

        onChangeSearchUserId: async function () {
            this.search.user_id = this.selectedUser?.id
            await this.setQuery({ key: 'user_id', value: this.search.user_id })
            await this.fetchAudits(1)
        },

        onChangeSearchOrganizationId: async function () {
            this.search.organization_id = this.selectedOrganization?.id
            await this.setQuery({ key: 'organization_id', value: this.search.organization_id })
            await this.fetchAudits(1)
        },

        onChangeSearchCompanyId: async function () {
            this.search.company_id = this.selectedCompany?.id
            await this.setQuery({ key: 'company_id', value: this.search.company_id })
            await this.fetchAudits(1)
        },

        /**
         * 会員一覧取得（multiselect）
         */
        fetchUsersMultiselect: function () {
            const endpoint = constants.admin.users.endpoint.base
            return axios.get(`${endpoint}/multiselect`)
                .then(({data}) => {
                    this.users = data.data
                    this.users.unshift({
                        id: null,
                        full_name: '',
                        full_name_kana: '',
                        label: `${this.$locale.patient}で検索`,
                    })
                })
        },

        /**
         * 団体一覧取得（multiselect）
         */
        fetchOrganizationsMultiselect: function () {
            const endpoint = constants.admin.groups.endpoint.base
            return axios.get(`${endpoint}/multiselect?group_type=2`)
                .then(({data}) => {
                    this.organizations = data.data
                    this.organizations.unshift({
                        id: null,
                        name: '',
                        label: '団体で検索',
                    })
                })
        },

        /**
         * 法人一覧取得（multiselect）
         */
        fetchCompaniesMultiselect: function () {
            const endpoint = constants.admin.groups.endpoint.base
            return axios.get(`${endpoint}/multiselect?group_type=1`)
                .then(({data}) => {
                    this.companies = data.data
                    this.companies.unshift({
                        id: null,
                        name: '',
                        label: '法人で検索',
                    })
                })
        },

        /**
         * 監査ログ一覧取得
         * @param {number|object} param
         */
        fetchAudits: async function (param = null) {
            this.audits = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.audits.endpoint.base

            return axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.audits = data.data
                    this.setQuery({key: 'current_page', value: data.current_page})
                    this.setQuery({key: 'per_page', value: data.per_page})
                    this.setQuery({key: 'total', value: data.total})
                    this.setQuery({key: 'from', value: data.from})
                    this.setQuery({key: 'to', value: data.to})
                })
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.$store.state.adminAudits

            if (paginate) {
                query += `page=${state.current_page}`
            }
            query += `&sort=${state.sortBy}`
            query += `&desc=${state.sortDesc}`

            if (state.created_at_gte) {
                query += `&created_at_gte=${state.created_at_gte}`
            }
            if (state.created_at_lte) {
                query += `&created_at_lte=${state.created_at_lte}`
            }
            if (state.user_type) {
                query += `&user_type=${state.user_type}`
            }
            if (state.user_id) {
                query += `&user_id=${state.user_id}`
            }
            if (state.organization_id) {
                query += `&organization_id=${state.organization_id}`
            }
            if (state.company_id) {
                query += `&company_id=${state.company_id}`
            }

            return query
        },

        /**
         * 操作ログCSVダウンロード
         */
        onCsvDownload: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.audits.endpoint.base
            const options = { responseType : 'blob' }

            axios.get(`${endpoint}/export${this.buildQuery(false)}`, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(blob, `audits_${moment().format('YYYYMMDD')}.csv`)
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },
    },
};
</script>

<style lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';

.adminAuditsWrapper {
    .b-table {
        min-width: 1800px;

        th, td {
            font-size: 0.75rem;
        }
    }

    @media (max-width: 767px) {
        .multiselect {
            width: 100%;
        }
    }
}
</style>

<style scoped lang="scss">
.btnCsvDownload {
    min-width: 142px;
}
</style>
